import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Listen for turbo:before-frame-render to update tab styling and title
    document.addEventListener('turbo:before-frame-render', this.updateTabStyling.bind(this))
  }

  disconnect() {
    document.removeEventListener('turbo:before-frame-render', this.updateTabStyling.bind(this))
  }

  updateTabStyling(event) {
    // Only process if it's our frame
    if (event.target.id !== 'top_streaming_tables_content') return

    // Get the URL from the frame element's src attribute
    const frameSrc = event.target.getAttribute('src')
    if (!frameSrc) return

    const url = new URL(frameSrc, window.location.origin)
    const bottomTab = url.searchParams.get('bottom_tab') || 'songs'

    const songsTab = document.getElementById('songs-tab-link')
    const territoriesTab = document.getElementById('territories-tab-link')
    const title = document.getElementById('streaming-tab-title')
    const tooltip = document.getElementById('streaming-tab-tooltip')

    if (!songsTab || !territoriesTab || !title || !tooltip) return

    if (bottomTab === 'songs') {
      // Activate songs tab
      songsTab.classList.remove('text-gray-500', 'hover:text-gray-700')
      songsTab.classList.add('text-indigo-600', 'border-b-2', 'border-indigo-600')

      // Deactivate territories tab
      territoriesTab.classList.remove('text-indigo-600', 'border-b-2', 'border-indigo-600')
      territoriesTab.classList.add('text-gray-500', 'hover:text-gray-700')

      // Update title and tooltip
      title.textContent = 'Top Songs'
      tooltip.setAttribute('data-tooltip-text-value', 'A list of your top performing songs by streams across the DSPs, location, and timeframe selected in the filters.')
    } else if (bottomTab === 'territories') {
      // Activate territories tab
      territoriesTab.classList.remove('text-gray-500', 'hover:text-gray-700')
      territoriesTab.classList.add('text-indigo-600', 'border-b-2', 'border-indigo-600')

      // Deactivate songs tab
      songsTab.classList.remove('text-indigo-600', 'border-b-2', 'border-indigo-600')
      songsTab.classList.add('text-gray-500', 'hover:text-gray-700')

      // Update title and tooltip
      title.textContent = 'Top Territories'
      tooltip.setAttribute('data-tooltip-text-value', 'A list of your top performing territories by streams across the DSPs and timeframe selected in the filters.')
    }
  }
}
